var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70071 48.9997C5.97867 46.3707 3.80748 43.2259 2.31382 39.7487C0.820167 36.2716 0.0339598 32.5319 0.00107607 28.7476C-0.0318077 24.9634 0.689291 21.2106 2.1223 17.708C3.5553 14.2055 5.67151 11.0234 8.34746 8.34746C11.0234 5.67151 14.2055 3.5553 17.708 2.1223C21.2106 0.689291 24.9634 -0.0318077 28.7476 0.00107607C32.5319 0.0339598 36.2716 0.820167 39.7487 2.31382C43.2259 3.80748 46.3707 5.97867 48.9997 8.70071C54.1912 14.0759 57.0639 21.275 56.9989 28.7476C56.934 36.2203 53.9367 43.3684 48.6525 48.6525C43.3684 53.9367 36.2203 56.934 28.7476 56.9989C21.275 57.0639 14.0759 54.1912 8.70071 48.9997ZM26.0002 14.6002V31.7002H31.7002V14.6002H26.0002ZM26.0002 37.4002V43.1002H31.7002V37.4002H26.0002Z",
    fill: "#F4C745"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutAlert);
export default __webpack_public_path__ + "static/media/logoutAlert.e5306681a6c9050b3f059814b6f40d96.svg";
export { ForwardRef as ReactComponent };